import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';

import { AutomationCompleteMailDTO, AutomationList, AutomationListRequestDTO, Role, triggerdetailforautomation, TriggerDetails, User, UserDetail } from '../_models';

import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { AutomationRequest } from '@app/_models/automationRequest';
import { UserSendLinkDto } from '@app/_models/createAccount';
import { first } from 'rxjs/internal/operators/first';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConnectionService } from './connection.service';
import { AlertService } from './alert.service';
import { BaseService } from './base.service';



@Injectable({ providedIn: 'root' })
export class AutomationService extends BaseService {
  
  constructor(
    private http: HttpClient,
    private connectionservice: ConnectionService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService
  ) {
    super();
  }
  TriggerDetailForAutomation(auid: string, uid:string) {
    return this.http.post<any>(`${environment.apiUrl}/Automation/TriggerDetailForAutomation`, { auid,uid });
  }

  GetTriggerDetailsForAutomation(auid: string) {
    return this.http.post<any>(`${environment.apiUrl}/Automation/get-trigger-details-for-automation/${auid}`, {  });
  }


  AutomationWebHookPost(apiendpoint: string, endpointusertoken: string, webhookurl: string, AutoamtionFlag: string) {
    return this.http.post<any>(`${environment.apiUrl}/Automation/AutomationWebHookPost`, { apiendpoint, endpointusertoken, webhookurl, AutoamtionFlag});
  }

  AutomationWebHookPut(apiendpoint: string, endpointusertoken: string, webhookurl: string, AutoamtionFlag: string) {
    return this.http.put<any>(`${environment.apiUrl}/Automation/AutomationWebHook`, { apiendpoint, endpointusertoken, webhookurl, AutoamtionFlag });
  }

  AutomationWebHookDelete(apiendpoint1: string, endpointusertoken: string, AutoamtionFlag: string, uId:string) {
    var apiendpoint = apiendpoint1.concat('Remove')
    return this.http.put<any>(`${environment.apiUrl}/Automation/AutomationWebHookRemove/${uId}`, { apiendpoint, endpointusertoken, AutoamtionFlag });
  }

  AutomationTeamsReinstall(auid: string) {
    return this.http.post<any>(`${environment.apiUrl}/Automation/AutomationReinstall`, { auid });
  }


  
  getAutomationRequestByReqId(reqId2): Observable<AutomationRequest> {
    const payload={reqId:`${reqId2}`}
    return this.http.post<AutomationRequest>(`${environment.apiUrl}/Automation/get-automation-req-detail`,payload)
  }
  sendAutomationRequestToSherpa(payload: UserSendLinkDto): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/automation/send-automation-request-to-sherpa`, payload)
  }

  addAutomationRequest(payload: any): Observable<boolean> {
    return this.http.post<any>(`${environment.apiUrl}/automation/add-automation-on-request`, payload)
  }
  getAutomationList(payload: AutomationListRequestDTO): Observable<AutomationList[]> {
    return this.http.post<AutomationList[]>(`${environment.apiUrl}/automation/get-automation-list`, payload)
  }
  getUserAutomationList(uid:string): Observable<AutomationList[]> {
    return this.http.get<AutomationList[]>(`${environment.apiUrl}/automation/get-user-automation-list/${uid}`)
  }

  mailOnAutomationComplete(auid:string,): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/automation/send-automation-complete-mail/${auid}`, {})
  }

  activateAutomation(auid:any,user:User,callBack) {
    if(!auid || !user){
      //this.navigateToAutoList(true,user.uId);
      callBack({status:false,msg:'Invalid User'});
      return;
    }
    this.GetTriggerDetailsForAutomation(auid)
      .pipe(first())
      .subscribe(
        data => {

          if (data) {
            let triggerDetails: TriggerDetails = data;
            let flg = '';
            if (triggerDetails.weebHookDetail != null && triggerDetails.weebHookDetail.webhookurl.includes("RequestTeam")) {
              flg = 'TEAMS'
            } else {
              flg = 'SLACK'
            }

            if (triggerDetails.triggerDetailForAutomation.apiendpoint) {
              this.AutomationWebHookPost(triggerDetails.triggerDetailForAutomation.apiendpoint,
                triggerDetails.triggerDetailForAutomation.endpintusertoken, triggerDetails.weebHookDetail.webhookurl + auid, flg)
                .pipe(first())
                .subscribe(
                  data2 => {
                    if (data2) {
                      this.connectionservice.ActiveAutomation(auid,user.uId)
                        .pipe(first())
                        .subscribe(
                          data2 => {
                            try {
                              if (user && user.role == Role.Client && user.name != null) {
                                this.mailOnAutomationComplete(auid).subscribe(x => { });
                              }
                            } catch { }
                           // this.alertService.success(data2.message, { keepAfterRouteChange: true });
                            //this.spinner.hide();
                           // this.navigateToAutoList(isNavigateToAutoList,user.uId);
                           callBack({status:true,msg:data2.message});
                          },
                          error => {
                           // this.spinner.hide();
                           // this.navigateToAutoList(isNavigateToAutoList,user.uId);
                            callBack({status:false,msg:''});
                          });
                    }
                    else {
                      this.alertService.error('Invalid User token', { keepAfterRouteChange: true });
                     // this.spinner.hide();
                      //this.navigateToAutoList(isNavigateToAutoList,user.uId);
                      callBack({status:false,msg:''});
                    }
                  },
                  error => {
                    if (error == "Bad Request"){
                      callBack({status:false,msg:'Invalid Authentication URL OR server is Down'});
                    }
                     // error = "Invalid Authentication URL OR server is Down";
                    //this.spinner.hide();
                    //this.alertService.error(error,{ keepAfterRouteChange: true });
                    //this.navigateToAutoList(isNavigateToAutoList,user.uId);


                  }
                )
            } else {
              //this.spinner.hide();
              //this.navigateToAutoList(isNavigateToAutoList,user.uId);
              callBack({status:false,msg:''});
            }
          }
        },
        error => {
          if (error == "Unauthorized"){
            error = "Invalid Authentication URL OR server is Down";
            //this.navigateToAutoList(isNavigateToAutoList,user.uId);
            callBack({status:false,msg:error});
          }
        });
  }
  // navigateToAutoList(isNavigateToAutoList,userUID:any){
  //   if(isNavigateToAutoList){
  //     const link="./connection/success";
  //     this.router.navigate([link]);
  //   }
  // }

  getTriggerDetailsForAuotmationByRole(role:Role,uid:any,aUID:any, callBack){
    if(role==Role.Admin){
      this.GetTriggerDetailsForAutomation(aUID)
      .pipe(first())
      .subscribe(
        data => {
          callBack(data);
        },
        error => {
          if (error == "Unauthorized"){
            error = "Invalid Authentication URL OR server is Down";
            this.alertService.error(error);
          }
          this.spinner.hide();
        })
      }
    else if(role==Role.Client){
      this.TriggerDetailForAutomation(aUID,uid)
      .pipe(first())
      .subscribe(
        data => {
          callBack(data);
        },
        error => {
          if (error == "Unauthorized"){
            error = "Invalid Authentication URL OR server is Down";
            this.alertService.error(error);
          }
          this.spinner.hide();
        })
    }

  }

  spinnerProgressBarToggle(show){
    if(show){
      this.spinner.show();
    }
    this.spinner.hide()
  }
}
